import {
    GET_PORTAL_LINKS,
    GET_PORTAL_LINKS_SUCCESS,
    GET_PORTAL_LINKS_FAIL,
    ADD_PORTAL_LINK,
    ADD_PORTAL_LINK_SUCCESS,
    ADD_PORTAL_LINK_FAIL,
    UPDATE_PORTAL_LINK,
    UPDATE_PORTAL_LINK_SUCCESS,
    UPDATE_PORTAL_LINK_FAIL,
    DELETE_PORTAL_LINK,
    DELETE_PORTAL_LINK_SUCCESS,
    DELETE_PORTAL_LINK_FAIL,
    SET_PORTAL_LINKS_FIELD_ERRORS,
} from './actionTypes';

const initialState = {
    portalLinks: [],
    loading: false,
    error: null,
    fieldErrors: {},
    refreshTrigger: 0,
};

const portalLinksReducer = (state = initialState, action) => {
    switch (action.type) {
        // Get Portal Links
        case GET_PORTAL_LINKS:
            return { ...state, loading: true };
        case GET_PORTAL_LINKS_SUCCESS:
            return { ...state, loading: false, portalLinks: action.payload };
        case GET_PORTAL_LINKS_FAIL:
            return { ...state, loading: false, error: action.payload };

        // Add Portal Link
        case ADD_PORTAL_LINK:
            return { ...state, loading: true };
        case ADD_PORTAL_LINK_SUCCESS:
            return { ...state, loading: false, fieldErrors: {}, refreshTrigger: state.refreshTrigger + 1 };
        case ADD_PORTAL_LINK_FAIL:
            return { ...state, loading: false, error: action.payload };

        // Update Portal Link
        case UPDATE_PORTAL_LINK:
            return { ...state, loading: true };
        case UPDATE_PORTAL_LINK_SUCCESS:
            return { ...state, loading: false, fieldErrors: {}, refreshTrigger: state.refreshTrigger + 1 };
        case UPDATE_PORTAL_LINK_FAIL:
            return { ...state, loading: false, error: action.payload };

        // Delete Portal Link
        case DELETE_PORTAL_LINK:
            return { ...state, loading: true };
        case DELETE_PORTAL_LINK_SUCCESS:
            return { ...state, loading: false, refreshTrigger: state.refreshTrigger + 1 };
        case DELETE_PORTAL_LINK_FAIL:
            return { ...state, loading: false, error: action.payload };

        // Field Errors
        case SET_PORTAL_LINKS_FIELD_ERRORS:
            return { ...state, fieldErrors: action.payload, loading: false };

        default:
            return state;
    }
};

export default portalLinksReducer;
